import React from "react"
import Img from "@kframesa/react-crosscast-lazy-image"
import styled, { css } from "styled-components"

import { Pic } from "../../styled/pic-info"

const Wrapper = styled.div`
  position: relative;

  ${({ large }) =>
    large &&
    css`
      &&& {
        left: 50%;
        transform: translateX(-50%);
        width: 100vw;

        @media only screen and (min-width: ${props => props.theme.mq.medium}) {
          width: 960px;
        }
      }
    `};
`

const Image = ({ alt, slug, title, guid, caption, credits, large, width, height, ext }) => {
  const getFluidConfig = () => {
    if (large) {
      return {
        maxWidth: 960,
        size: 425,
        step: 343,
        sizes: [`(max-width: 425px) 425px`, `(max-width: 768px) 768px`, `960px`],
      }
    }

    return {
      maxWidth: 690,
      size: 385,
      step: 305,
      sizes: [`(max-width: 425px) 385px`, `690px`],
    }
  }

  return (
    <Wrapper large={large}>
      {credits ? <Pic.Credits>{credits}</Pic.Credits> : null}
      <Img
        alt={alt}
        title={title}
        platformSlug={slug}
        imageGuid={guid}
        fluid={getFluidConfig()}
        width={width}
        height={height}
        ext={ext}
      />
      {caption ? <Pic.Caption>{caption}</Pic.Caption> : null}
    </Wrapper>
  )
}

export default Image
